import { FC, useState } from "react";
import { SketchPicker } from "react-color";
import styles from "./ColorField.module.scss";

interface IColorField {
  label?: string;
  value: string;
  onChange: (value: string) => void;
}

export const ColorField: FC<IColorField> = ({ label, value, onChange }) => {
  const [color, setColor] = useState(value ?? "#000");
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (color) => {
    setColor(color.hex);
    onChange(color.hex);
  };

  const handleChangeComplete = (color) => {
    handleChange(color);
   // handleClose();
  };

  return (
    <div className={styles.wrapper}>
      {label ? <span>{label}</span> : null}
      <div className={styles.swatch} onClick={handleClick}>
        <div className={styles.color} style={{ background: color }} />
      </div>
      {displayColorPicker ? (
        <div className={styles.popover}>
          <div className={styles.cover} onClick={handleClose} />
          <SketchPicker
            color={color}
            onChange={handleChange}
            onChangeComplete={handleChangeComplete}
          />
        </div>
      ) : null}
    </div>
  );
};
